import { AnimationController } from '@ionic/angular';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GeneralModalAnimation {
  getAnimations() {
    const animation = {
      enterAnimation: (baseEl: any) => {
        const animationCtrl = new AnimationController();

        const wrapperAnimation = animationCtrl
          .create()
          // tslint:disable-next-line: no-non-null-assertion
          .addElement(baseEl.querySelector('.modal-wrapper')!)
         // .fromTo('transform', 'translate3d(0, 0,  0)', 'translate3d(0,20%,0')
          .fromTo('opacity', 0.01, 0.4);  

        return animationCtrl
          .create()
          .addElement(baseEl)
          .duration(400)
          .addAnimation([wrapperAnimation]);
      },
      leaveAnimation: (baseEl: any) => animation.enterAnimation(baseEl).direction('reverse'),
    };

    return animation;
  }
}
